import React from 'react';

function Defaultchat() {
  return (
    <div
      className="d-flex align-items-center justify-content-center h-100"
      style={{
        backgroundColor: "#E5DDD5",
        backgroundImage: "radial-gradient(circle at 1px 1px, rgba(0,0,0,0.04) 1px, transparent 0)",
        backgroundSize: "24px 24px",
        height: "100%",
        width: "100%",
        minHeight: "300px",
      }}
    >
      <div className="text-center p-4">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
          style={{ 
            width: "80px", 
            height: "80px", 
            backgroundColor: "rgba(255,255,255,0.85)", 
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            border: "1px solid #e2e8f0",
            backdropFilter: "blur(8px)"
          }}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" fill="#075E54" />
          </svg>
        </div>
        <div
          className="bg-white rounded-4 p-4"
          style={{ 
            maxWidth: "340px",
            border: "1px solid #cbd5e1",
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            backdropFilter: "blur(12px)",
            backgroundColor: "rgba(255,255,255,0.92)"
          }}
        >
          <h5 className="text-dark mb-2 fw-bold" style={{ color: '#1e293b' }}>WhatsApp Chat</h5>
          <p className="text-secondary mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
            Select a contact from the list to start or continue a conversation.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Defaultchat;
